import React, { useCallback } from 'react';
import { type BaseFormFieldNodeProperties } from '@leagueplatform/masonry-engine';
import { useInvokeAction } from './use-invoke-action.hook';

/**
 * Returns a callback that clears `inputStatus` and `statusMessage` from the
 * Masonry node state when any validation status or message is present.
 *
 * The full `formFieldProperties` spread is required because the
 * `setNodeState` action handler performs a shallow merge at the top level,
 * which would otherwise replace the entire `formFieldProperties` object.
 */
export const useClearValidationStatus = (
  formFieldProperties: BaseFormFieldNodeProperties['formFieldProperties'],
) => {
  const invokeAction = useInvokeAction();

  return useCallback(
    (event: React.SyntheticEvent) => {
      if (
        formFieldProperties.inputStatus ||
        formFieldProperties.statusMessage
      ) {
        invokeAction({
          event,
          type: 'setNodeState',
          namespace: 'default',
          payload: {
            state: {
              formFieldProperties: {
                ...formFieldProperties,
                inputStatus: undefined,
                statusMessage: undefined,
              },
            },
          },
        });
      }
    },
    [formFieldProperties, invokeAction],
  );
};
